import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AddPhotoAlternate from '@material-ui/icons/AddPhotoAlternate';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import WarningBar from './WarningBar';
import Hidden from '@material-ui/core/Hidden';
import { withData } from '../utility/DataContext';


const styles = theme => ({
  root: {
    marginBottom: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit * 5,
    paddingBottom: theme.spacing.unit * 5,
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonIcon: {
    marginLeft: theme.spacing.unit,
    color: 'rgba(0, 0, 0, 0.3)',
  },
  dragDiv: {
    backgroundColor: theme.palette.primary.main,
    padding: 10,
    borderRadius: 4,
    marginBottom: 5,
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2)',
  },
  dragIcon: {
    color: 'rgba(0, 0, 0, 0.3)',
    fontSize: 60,
  },
  input: {
    position: 'absolute',
    top: -9999,
    opacity: 0
  },
});

const dragStyle = {
  position: 'relative',
  boxShadow: '0 0 0 ' + Math.max(window.outerWidth, window.outerHeight) + 'px rgba(0, 0, 0, 0.5)',
  zIndex: 1500
}

class UploadArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warningToggle: false,
      dragging: false,
    };
    this.input = null;
    this.dragEnterCounter = 0;
  }

  onFileGet = event => {
    event.preventDefault();
    if (event.target.files.length > 0){
      this.checkFile(event.target.files[0])
    }
  }

  onDrop = event => {
    event.preventDefault();
    if (event.dataTransfer.files.length > 0){
      this.checkFile(event.dataTransfer.files[0])
    }
    if (this.state.dragging){
      this.setState({dragging: false});
    }
  }

  checkFile = file => {
    if (file.type.startsWith('image')){
      this.props.data.set('file', file);
      this.props.history.push('/upload');
    }else{
      this.setState({warningToggle: !this.state.warningToggle});
    }
  }

  componentDidMount() {
    document.addEventListener('drop', this.onDrop);
    document.addEventListener('dragenter', this.onDragEnter);
    document.addEventListener('dragover', this.onDragOver);
    document.addEventListener('dragleave', this.onDragLeave);
  }

  componentWillUnmount() {
    document.addEventListener('drop', this.onDrop);
    document.removeEventListener('dragenter', this.onDragEnter);
    document.removeEventListener('dragover', this.onDragOver);
    document.removeEventListener('dragleave', this.onDragLeave);
  }

  onDragEnter = event => {
    event.preventDefault();
    this.dragEnterCounter += 1;
  }

  onDragOver = event => {
    event.preventDefault();
    if (event.dataTransfer.types.includes('Files') && !this.state.dragging){
      this.setState({dragging: true});
    }
  }

  onDragLeave = event => {
    event.preventDefault();
    this.dragEnterCounter -= 1;
    if (event.dataTransfer.types.includes('Files') && this.state.dragging && this.dragEnterCounter === 0){
      this.setState({dragging: false});
    }
  }

  render() {
    const {classes} = this.props;
    const s = this.state.dragging ? dragStyle : {};
    return (
      <Paper className={classes.root} style={s}>
        <input className={classes.input} ref={elm => this.input = elm} onChange={this.onFileGet} type='file' />
        <Grid container justify="center" alignItems="center">
        {
          this.state.dragging
          ? <div style={{textAlign: 'center'}}>
              <div className={classes.dragDiv}>
                <AddPhotoAlternate className={classes.dragIcon} />           
              </div>
              <Typography variant="subheading">
                拖移到這裡上傳
              </Typography>
            </div>
          : <React.Fragment>
              <Button variant="contained" color="primary" onClick={() => {this.input.click()}} className={classes.button}>
                開啟圖片
              <AddPhotoAlternate className={classes.buttonIcon} />
              </Button>
              <Hidden xsDown>
                <Typography variant="body1">
                  或拖移到這裡
                </Typography>
              </Hidden>
            </React.Fragment>
        }
        </Grid>
        <WarningBar content='上傳的檔案不是圖片！' trigger={this.state.warningToggle} />
      </Paper>
    );
  }
}

export default withData(withRouter(withStyles(styles)(UploadArea)));


// WEBPACK FOOTER //
// ./src/components/UploadArea.js